module.exports = __webpack_public_path__ + "img/event_icon_taptakeover_white.926ea090.png";